import * as React from 'react';
import { isEmpty } from 'ramda';
import { ICommercialSpecialtySchema, ISpecialtySchema } from '@cian/api-models/offer-card/v1/get-offer-data';
import { Office, Warehouse, TradeArea, Manufacture } from '../icons';

export interface ISpecialtyIcon {
  icon?: React.ReactNode;
  title?: string;
}

export interface ISpecialtyView {
  specialtiesIcon?: ISpecialtyIcon[];
  specialtiesString?: string;
}

export const TOP_SPECIALTIES = [7026, 7113, 7128, 7104];

export const TOP_SPECIALTIES_ICONS = new Map<number, React.ReactNode>([
  [7026, Office],
  [7113, Warehouse],
  [7128, TradeArea],
  [7104, Manufacture],
]);

export const getSpecialties = (specialty: ICommercialSpecialtySchema | null): ISpecialtyView => {
  const defaultResult = {} as ISpecialtyView;
  /**
   * Если в указано что этот ПСН под автосервис, общепит или бытовые услуги,
   * то это выводится в заголовке, тут в описании вывод "Возможное назначение:..." скрывается
   */
  if (
    specialty &&
    Array.isArray(specialty.types) &&
    specialty.types.length === 1 &&
    ['carService', 'publicCatering', 'domesticServices'].includes(specialty.types[0])
  ) {
    return defaultResult;
  }

  if (specialty) {
    const { specialties } = specialty;
    if (specialties) {
      const specialtiesIcon: ISpecialtyIcon[] = TOP_SPECIALTIES.map(topSpecialty => {
        const specialty = specialties.find(specialty => specialty.id === topSpecialty);
        if (specialty && specialty.id && specialty.rusName) {
          return {
            title: specialty.rusName,
            icon: TOP_SPECIALTIES_ICONS.get(specialty.id),
          };
        }

        return {};
      }).filter(specialty => !isEmpty(specialty));

      const specialtiesString = specialties
        .reduce((acc: string[], next: ISpecialtySchema) => {
          if (next.id && !TOP_SPECIALTIES.includes(next.id) && next.rusName) {
            acc.push(next.rusName.toLowerCase());
          }

          return acc;
        }, [])
        .join(', ');

      return {
        specialtiesIcon,
        specialtiesString,
      };
    }

    return defaultResult;
  }

  return defaultResult;
};
